import React from "react";
import axios from 'axios';
import { Link } from "react-router-dom";

import "./ListaHardware.css";
import StatusBadge from '../StatusBadge/StatusBadge';
import verificandoToken from '../../../../FuncoesGerais/VerificarToken';
import { ensureProtocol } from '../../../../config/backend';

function ListaHardwares(props) {

    const deleteHardware = async (codHar) => {
        if (codHar == null || codHar === '') {
            alert('Código do hardware não identificado.');
            return;
        }

        let confirmacao = window.confirm("Você realmente deseja excluir o hardware " + codHar + "?");

        verificandoToken();

        const token = localStorage.getItem('token');

        if (confirmacao) {
            try {

                const baseUrl = ensureProtocol(localStorage.getItem("ipBackend2")) + "/hardware";
                await axios.delete(`${baseUrl}?codHar=${encodeURIComponent(codHar)}`, {
                    headers: {
                        Authorization: `${token}`
                    }
                });

                alert("Hardware " + codHar + " deletado com sucesso!");

                window.location.reload();

            } catch (error) {
                console.error('Erro:', error);
            }
        }
    };

    const list = props.arraysHardware || [];
    const handleRowClick = (e, assetId) => {
        if (props.onOpenDrawer && !e.target.closest('button') && !e.target.closest('a')) props.onOpenDrawer(assetId);
    };
    return (
        <div className="lista-wrapper">
            <table className="table table-modern align-middle inventario-table">
                <thead>
                    <tr>
                        <th scope="col">Código</th>
                        <th scope="col">Série</th>
                        <th scope="col">Equip.</th>
                        <th scope="col">Patrimônio</th>
                        <th scope="col">Descrição</th>
                        <th scope="col">Status</th>
                        <th scope="col" width="140">Ações</th>
                    </tr>
                </thead>
                <tbody>
                    {list.map((hardware, index) => {
                        const cod = hardware.codhar ?? hardware.CODHAR;
                        const assetId = hardware.id ?? cod;
                        const sit = (hardware.siteqp ?? hardware.SITEQP ?? '').toString();
                        const comVinculo = Boolean(hardware.comVinculo);
                        return (
                        <tr
                            key={cod != null ? cod : `har-${index}`}
                            className={props.onOpenDrawer ? 'inventario-table__row--clickable' : ''}
                            onClick={props.onOpenDrawer ? (e) => handleRowClick(e, assetId) : undefined}
                        >
                            <td>{cod}</td>
                            <td>
                                {props.onOpenDrawer ? (
                                    <button type="button" className="btn btn-link p-0 text-start" onClick={(e) => { e.stopPropagation(); props.onOpenDrawer(assetId); }}>{hardware.sereqp ?? hardware.SEREQP}</button>
                                ) : props.onEdit ? (
                                    <button type="button" className="btn btn-link p-0" onClick={() => props.onEdit(cod)}>{hardware.sereqp ?? hardware.SEREQP}</button>
                                ) : (
                                    <Link to={{ pathname: '/listaHardware', state: { editId: cod } }}>{hardware.sereqp ?? hardware.SEREQP}</Link>
                                )}
                            </td>
                            <td>{hardware.codeqp ?? hardware.CODEQP}</td>
                            <td>{hardware.pateqp ?? hardware.PATEQP}</td>
                            <td><span className="text-truncate d-inline-block" style={{ maxWidth: 180 }} title={hardware.deseqp ?? hardware.DESEQP}>{((hardware.deseqp ?? hardware.DESEQP) || '').substring(0, 80)}{((hardware.deseqp ?? hardware.DESEQP) || '').length > 80 ? '…' : ''}</span></td>
                            <td><StatusBadge siteqp={sit} comVinculo={comVinculo} /></td>
                            <td onClick={(e) => e.stopPropagation()}>
                                <div className="d-flex flex-nowrap gap-1 align-items-center">
                                    {props.onOpenDrawer && (
                                        <button type="button" className="btn btn-outline-primary btn-sm" title="Ver detalhe" onClick={() => props.onOpenDrawer(assetId)}><i className="fas fa-eye" /></button>
                                    )}
                                    {props.onEdit && (
                                        <button type="button" className="btn btn-outline-secondary btn-sm" title="Editar" onClick={() => props.onEdit(cod)}><i className="fas fa-edit" /></button>
                                    )}
                                    <Link to={'/listaHisHar/' + cod} className="btn btn-secondary btn-sm" title="Histórico"><i className="fas fa-history" /></Link>
                                    <button className="btn btn-danger btn-sm" onClick={() => deleteHardware(cod)} type="button" title="Excluir"><i className="fas fa-trash" /></button>
                                </div>
                            </td>
                        </tr>
                    );})}
                </tbody>
            </table>
        </div>
    );
}

export default ListaHardwares;
